// extracted by mini-css-extract-plugin
module.exports = {"imageFigure":"Image_imageFigure__37NzL","imageFigureCaption":"Image_imageFigureCaption__1317B","imageFigureLoading":"Image_imageFigureLoading__2j2oM"};